// extracted by mini-css-extract-plugin
export default {"centered":"TrolleyScreen_centered__0l8cP"};